export * from './dashboard-sorter.component';
export * from './dashboard-sorter.component.module';